<script>
    import { doc, collection, onSnapshot, query, where, updateDoc, serverTimestamp, addDoc, deleteDoc, orderBy, arrayUnion, arrayRemove, Timestamp } from "firebase/firestore";
    import { db } from "../../firebase/firestore";
    import { user, business } from "../../firebase/auth";
    import CardsList from "../../components/cards/CardsList.svelte";
    import { offsetDate, offsetTimestamp } from "../../utils/utils";
    import { navigate } from "svelte-routing";

    async function add(e) {
        const data = e.detail.data;
        data.end = offsetTimestamp(data.end, 1);
        data.redeemableUntil = offsetTimestamp(data.redeemableUntil, 1);
        data.businesses = [$business.id];
        data.owner = $user.uid;
        data.created = serverTimestamp();
        data.state = "incomplete";
        data.rewardSystem = {type: "all", rewards: []};
        console.log("Adding CardSetting")
        console.log(data);
        try {
            let ref = collection(db, "cardSettings");
            const docRef = await addDoc(ref, data);
            navigate("/stempelkarten/"+docRef.id)
        } catch (error) {
            console.log(error)
        }
    }

    export let cards;
    export let blocked;
    
    async function setAutoRenewal(e) {
        const id = e.detail.id;
        const data = e.detail.data;
        try {
            let ref = doc(db, "cardSettings", id);
            await updateDoc(ref, data);
        } catch (error) {
            alert("Die Änderung an der automatischen Verlängerung konnte nicht gespeichert werden. Gehe sicher, dass eine Internetverbindung besteht.")
            console.log(error)
        }
    }

    async function remove(e) {
        const id = e.detail.id;
        console.log("Deleting CardSetting")
        try {
            let ref = doc(db, "cardSettings", id);
            await deleteDoc(ref)
        } catch (error) {
            console.log(error)
        }
    }

    const cardSettingsRef = collection(db, "cardSettings");
</script>

{#if cards}
    <CardsList bind:cards bind:blocked on:add={add} on:remove={remove} on:setAutoRenewal={setAutoRenewal}></CardsList>
{/if}

<style>
</style>